import React, { useState } from "react";
import { useAsync } from "react-async-hook";
import {
  adminCreatePublicite,
  adminDeletePublicite,
  adminGetPublicites,
  adminGetServices,
  adminSetPublicite,
} from "src/app/api/AdminApi";
import AppSpinner from "src/commun/composants/AppSpinner/AppSpinner";
import AppFormik from "src/commun/composants/formulaire/formik/AppFormik";
import styles from "src/pages/admin/adminservices/AdminServicesForm.scss";
import AppRow from "src/commun/composants/grille/AppRow";
import AppCol from "src/commun/composants/grille/AppCol";
import { AdminPublicite, AdminPubliciteFormulaire } from "src/domain/AdminPublicite";
import AdminPubliciteFormContent from "src/pages/admin/adminpublicite/AdminPubliciteFormContent";
import useValidationPubliciteSchemaService from "src/pages/admin/adminpublicite/useValidationPubliciteSchemaService";
import { AdminService } from "src/domain/AdminService";

const AdminPubliciteForm = () => {


  const emptyAdminPublicite: AdminPublicite = {
    id: "",
    withIcone: false,
    flagNew: false,
    labelFr: "",
    labelDe: "",
    labelEn: "",
    contenuHtmlFr: "",
    contenuHtmlDe: "",
    contenuHtmlEn: "",
    serviceId: null,
    agence: ""
  };

  const validationSchema = useValidationPubliciteSchemaService();


  const publicites = useAsync(adminGetPublicites, []);

  const services = useAsync(adminGetServices, []);

  const [add, setAdd] = useState(false);

  const onDeleteCreate = () => {
    setAdd(false);
  };

  const onDeleteCallBack = (publicite: AdminPublicite) => {
    return (): void => {
      adminDeletePublicite(publicite).then(() => {
        submitSuccessHandler();
        setAdd(false);
      }).then(() => {
        setAdd(false);
      });

      // TODO: Implement delete logic here
    };
  };

  const submitSuccessHandler = () => {

    publicites.execute();
  };

  if (publicites.status === "loading" || services.status === "loading") {
    return <AppSpinner animation="grow"/>;
  }

  const mapToAdminPubliciteForm = (publicite: AdminPublicite) => {

    return {
      ...publicite,
      service: "",

    } as AdminPubliciteFormulaire;
  };

  const handleSubmitForm = (publicite: AdminPubliciteFormulaire) => {
    return adminSetPublicite({
      ...publicite,
    } as AdminPublicite);
  };


  const handleSubmitCreateForm = (publicite: AdminPublicite) => {
    setAdd(false);
    return adminCreatePublicite({
        ...publicite,
      },
    ).then(()=>publicites.execute());
  };

  return (
    <span className={`ferge-class`}>
      <AppRow>
        <AppCol md={{ span: 12 }}>
            <div className={`${styles.container}`}>
              <h2 className="appTitle">Administrer les publicites <input onClick={() => setAdd(true)} name="add" value={"+ AJouter Publicité "}/> </h2>

              {add &&
                <AppFormik
                  key={"addService"}
                  enableReinitialize
                  initialValues={emptyAdminPublicite}
                  submitFormAPI={(publicite: AdminPubliciteFormulaire) => handleSubmitCreateForm(publicite)}
                  submitSuccessHandler={submitSuccessHandler}
                  validationSchema={validationSchema}
                >
                  <AdminPubliciteFormContent delete={onDeleteCreate} services={[{ value: "", label: "" }, ...(services.result || []).map(item => ({
                    value: item.id.toString(),
                    label: item.labelFr,
                  }))]}/>


                </AppFormik>
              }

              {(publicites.result || []).map((publicite, index) => (
                <AppFormik
                  key={index}
                  enableReinitialize
                  initialValues={mapToAdminPubliciteForm(publicite)}
                  submitFormAPI={(publicite: AdminPubliciteFormulaire) => handleSubmitForm(publicite)}
                  submitSuccessHandler={submitSuccessHandler}
                  validationSchema={validationSchema}
                >
                  <AdminPubliciteFormContent delete={onDeleteCallBack(publicite)}
                                             services={[{ value: "", label: "" }, ...(services.result || []).map(item => ({
                                               value: item.id.toString(),
                                               label: item.labelFr,
                                             }))]}/>
                </AppFormik>
              ))}
            </div>
        </AppCol>
      </AppRow>
</span>
  );
};

export default AdminPubliciteForm;